import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import {
  assignProjectToOP,
  cancelOPResponseBeforeAssign,
} from "../../../../store/slices/managerProjectAssign";
import { useSnackbar } from "notistack";
import { jsPDF } from "jspdf";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { fetchWorkEntriesProjectTracking } from "../../../../store/slices/workentriesSlice";
import { fetchDescriptionTasksProjectTracking } from "../../../../store/slices/DescriptionTask";
import { fetchHardwareProjectTracking } from "../../../../store/slices/hardwareDescriptionSlice";
import { setProjectReadTrue } from "../../../../store/slices/readSlice";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import CommaConvert from "../../../../utils/CommaConvert";

const OldTaskDetailsHardware = ({
  row,
  matchedRowEntries,
  matchedRowDesctiption,
  employees,
  matchedRowHardwareEntries,
  setIsLoading,
  setSelectedEmpInDrop,
  selectedEmpInDrop,
  filteredCancelEmployee,
  setEmployeeWithTasks,
  employeeWithTasks,
  refreshAssign,
  isViewOnly = false,
}) => {
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();

  useEffect(() => {
    console.log("employeeWithTasks OldTaskDetailsHardware row", row);
    // console.log("employeeWithTasks OldTaskDetailsHardware",employeeWithTasks)
  }, [row]);

  const [empsToExclude, setEmpsToExclude] = useState([]);

  console.log("employeeWithTasks empsToExclude", empsToExclude);

  useEffect(() => {
    if (row?.Assignedperson?.length > 0 && employees?.length > 0) {
      const assignedEmails = row.Assignedperson.map((p) => p?.email);

      const mapIds = employees
        .filter((emp) => assignedEmails.includes(emp?.EmpEmail))
        .map((emp) => emp?._id);

      setEmpsToExclude(mapIds);
    }
  }, [row, employees]);

  useEffect(() => {
    const isExcluded = (emp) => {
      return row?.Assignedperson?.some((person) => {
        if (emp.customRoles?.[0] === "project manager") {
          return person.email === emp.EmpEmail;
        }
        return (
          person.projecttracktaskStatus === "submit" &&
          person.email === emp.EmpEmail
        );
      });
    };

    const merged = employees
      .map((emp) => {
        if (isExcluded(emp)) return null; // ⬅️ use helper here
        const workEntries = matchedRowEntries.filter(
          (entry) =>
            entry.taskownerid === emp?._id && entry.isProjectAssigned === false
        );
        const descriptions = matchedRowDesctiption.filter(
          (entry) =>
            entry.taskownerid === emp?._id && entry.isProjectAssigned === false
        );
        const hardwareItems = matchedRowHardwareEntries.filter(
          (entry) => entry.taskownerid === emp?._id
        );

        if (workEntries.length > 0 || descriptions.length > 0) {
          return {
            projectid: row?._id,
            ProjectName: row?.ProjectName,
            name: `${emp.EmpFirstName} ${emp.EmpLastName}`,
            email: emp.EmpEmail,
            empid: emp._id,
            role: emp.customRoles?.[0] || "—",
            TypeService: emp.servicetype,
            descriptionList: descriptions,
            hardwareItems: hardwareItems,
            workEntries,
          };
        }

        return null;
      })
      .filter(Boolean);
    const allEmpIds = merged.map((item) => item.empid);
    const finalData = {
      Assignedperson: merged,
      AllEmpIds: allEmpIds, // ⬅️ Add your new field here
      ProjectName: row?.ProjectName,
      TypeService: row?.TypeService,
      _id: row?._id,
      empsToExclude: empsToExclude,
    };
    setEmployeeWithTasks(finalData);
  }, [
    employees,
    matchedRowDesctiption,
    matchedRowEntries,
    row,
    matchedRowHardwareEntries,
    setEmployeeWithTasks,
    empsToExclude,
  ]);

  const [selectedTab, setSelectedTab] = useState({ index: null, tab: null });
  const [selectedEmp, setSelectedEmp] = useState({}); // parent state
  const [openCancelOpMenuIdx, setOpenCancelOpMenuIdx] = useState(null);
  const [openMenuIdx, setOpenMenuIdx] = useState(null);

  const [confirmAssignPopup, setConfirmAssignPopup] = useState(false);
  const [pendingAssignIndex, setPendingAssignIndex] = useState(null);
  const [selectedPerson, setSelectedPerson] = useState({});
  const [selectedHardwareParts, setSelectedHardwareParts] = useState({});
  const [selectedDescriptions, setSelectedDescriptions] = useState({});

  const wrapperRefs = useRef([]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRefs.current.every((ref) => ref && !ref.contains(event.target))
      ) {
        setOpenMenuIdx(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefCancelOp = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRefCancelOp.current &&
        !dropdownRefCancelOp.current.contains(e.target)
      ) {
        setOpenCancelOpMenuIdx(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [editedTasksByPerson, setEditedTasksByPerson] = useState({});

  useEffect(() => {
    if (
      employeeWithTasks?.Assignedperson &&
      Object.keys(editedTasksByPerson).length === 0
    ) {
      const initial = {};

      employeeWithTasks.Assignedperson.forEach((p, idx) => {
        initial[idx] = {
          empid: p.empid,
          projectid: p.projectid,
          tasks: p?.workEntries?.length
            ? [...p.workEntries]
            : [{ task: "", hoursassigned: "", notes: "" }],
        };
      });

      setEditedTasksByPerson(initial);
    }
  }, [employeeWithTasks, editedTasksByPerson]);

  const [editedDescriptionsByPerson, setEditedDescriptionsByPerson] = useState(
    {}
  );

  useEffect(() => {
    if (
      employeeWithTasks?.Assignedperson &&
      Object.keys(editedDescriptionsByPerson).length === 0
    ) {
      const initial = {};

      employeeWithTasks.Assignedperson.forEach((person, idx) => {
        initial[idx] = {
          empid: person.empid,
          projectid: person.projectid,
          descriptions:
            person?.descriptionList?.length > 0
              ? [...person.descriptionList]
              : [{ description: "", value: "", notes: "" }],
        };
      });

      setEditedDescriptionsByPerson(initial);
    }
  }, [employeeWithTasks, editedDescriptionsByPerson]);

  const handleOtherOPHardwareDescriptionAssign = async (index) => {
    if (isViewOnly) return;
    const payload = {
      projectId: row._id,
      newTaskOwnerId:
        selectedEmpInDrop && selectedEmpInDrop.index === index
          ? selectedEmpInDrop.emp?._id
          : selectedEmp[index]?._id,
      selectedHardwareDescriptions: (selectedHardwareParts[index] || []).map(
        (item) => item._id
      ),
      selectedDescriptionTasks: (selectedDescriptions[index] || []).map(
        (item) => item._id
      ),
    };
    const projectId = row._id;

    setIsLoading(true);
    try {
      await dispatch(assignProjectToOP(payload));
      await dispatch(setProjectReadTrue(projectId));
      enqueueSnackbar("Description & Hardware Parts Assigned", {
        variant: "success",
      });
      setSelectedEmpInDrop(null);
      setSelectedDescriptions({});
      setSelectedHardwareParts({});
      dispatch(fetchAllProjects());
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchHardwareProjectTracking());
    } catch {
      enqueueSnackbar("Failed to save Description", { variant: "error" });
    } finally {
      setIsLoading(false);
      refreshAssign();
    }
  };

  const handleSelectEmp = (index, emp) => {
    if (!emp || !emp._id) {
      console.error("Invalid employee selected");
      return;
    }
    setSelectedEmp((prev) => ({
      ...prev,
      [index]: emp,
    }));
  };

  useEffect(() => {
    if (
      employeeWithTasks?.Assignedperson?.length > 0 &&
      employees?.length > 0
    ) {
      employeeWithTasks.Assignedperson.forEach((person, index) => {
        const defaultEmp = employees.find((emp) => emp._id === person.empid);
        if (defaultEmp) {
          handleSelectEmp(index, defaultEmp);
          setSelectedHardwareParts((prev) => ({
            ...prev,
            [index]: person?.hardwareItems || [],
          }));
          setSelectedDescriptions((prev) => ({
            ...prev,
            [index]: person?.descriptionList || [],
          }));
        }
      });
    }
  }, [employeeWithTasks, employees]);

  const downloadPDFHardware = (hardwareList) => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [
        [
          "Sr. No",
          "Part Name",
          "Part Number",
          "Quantity",
          `Unit Price (${currency})`,
          `Total Price (${currency})`,
        ],
      ],
      body: hardwareList.map((LeadReport, index) => [
        index + 1,
        LeadReport.assemblepartdescription,
        LeadReport.partno,
        LeadReport.quantity,
        USAComma(LeadReport.unitprice),
        USAComma(LeadReport.totalprice),
      ]),
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
    });
    doc.save("Hardware PartList.pdf");
  };

  const downloadPDFHardwareDescriptions = (descriptionList) => {
    const doc = new jsPDF();
    doc.autoTable({
      head: [["Sr. No", "Description", `Amount (${currency})`, "Notes"]],
      body: descriptionList.map((LeadReport, index) => [
        index + 1,
        LeadReport.description,
        USAComma(LeadReport.value),
        LeadReport.notes,
      ]),
      styles: {
        fontSize: 7,
      },
      headStyles: {
        fontSize: 8,
      },
    });
    doc.save("Hardware OtherExpensesList.pdf");
  };

  const [cancelPerson, setCancelPerson] = useState(null);
  const [cancelEmpBeforeAssign, setCancelEmpBeforeAssign] = useState(false);

  const [selectedCancelAssignOpPerson, setSelectedCancelAssignOpPerson] =
    useState(null);

  const [cancelpopPerson, setCancelPopPerson] = useState(false);

  const handleCancelAssignOpSubmit = async (cancelPerson) => {
    if (isViewOnly) return;
    await handleAssignCancelOPData(cancelPerson);
  };

  const handleAssignCancelOPData = async (person) => {
    if (isViewOnly) return;
    const payload = {
      projectid: person.projectid,
      personid: person.empid,
    };
    setIsLoading(true);
    try {
      await dispatch(cancelOPResponseBeforeAssign(payload));
      dispatch(fetchAllProjects());
      dispatch(fetchWorkEntriesProjectTracking());
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchHardwareProjectTracking());
      setIsLoading(false);
    } catch {
      enqueueSnackbar(`Failed To Cancel Response`, {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setCancelEmpBeforeAssign(false);
      setCancelPerson(null);
    }
  };

  //   const handleCancelOpAssignSubmit = async (index) => {
  //     const payload = {
  //       projectId: row._id,
  //       newTaskOwnerId: selectedCancelAssignOpPerson?._id,
  //       selectedWorkEntries: cancelPerson?.workEntries.map((item) => item._id),
  //       selectedDescriptionTasks: cancelPerson?.descriptionList.map(
  //         (item) => item._id
  //       ),
  //     };
  //     const payloadHardware = {
  //       projectId: row._id,
  //       newTaskOwnerId: selectedCancelAssignOpPerson?._id,
  //       selectedHardwareDescriptions: cancelPerson?.hardwareItems.map(
  //         (item) => item._id
  //       ),
  //       selectedDescriptionTasks: cancelPerson?.descriptionList.map(
  //         (item) => item._id
  //       ),
  //     };

  //     const payloadToSend =
  //       row.TypeService === "Hardware" ? payloadHardware : payload;
  //     const projectId = row._id;
  //     setIsLoading(true);
  //     try {
  //       await dispatch(assignProjectToOP(payloadToSend));
  //       await dispatch(setProjectReadTrue(projectId));
  //       enqueueSnackbar(
  //         `Task Assigned To ${selectedCancelAssignOpPerson?.EmpFirstName} ${selectedCancelAssignOpPerson?.EmpLastName}`,
  //         { variant: "success" }
  //       );
  //       dispatch(fetchAllProjects());
  //       dispatch(fetchWorkEntriesProjectTracking());
  //       dispatch(fetchDescriptionTasksProjectTracking());
  //       dispatch(fetchHardwareProjectTracking());
  //       setIsLoading(false);
  //     } catch {
  //       enqueueSnackbar("Failed To Assign Task", {
  //         variant: "error",
  //       });
  //       setIsLoading(false);
  //     } finally {
  //       setIsLoading(false);
  //       refreshAssign();
  //     }
  //   };

  return (
    <div className="">
      {employeeWithTasks?.Assignedperson?.map((person, index) => (
        <div key={person?.email} className="flex w-full border-b">
          <div className="w-28 flex justify-start">
            <div
              ref={(el) => (wrapperRefs.current[index] = el)}
              className="w-[100%] relative flex flex-col justify-start p-0 rounded-xl"
            >
              <button
                type="button"
                disabled={isViewOnly}
                onClick={() => {
                  if (isViewOnly) return;
                  setOpenMenuIdx((prev) => (prev === index ? null : index));
                }}
                className={`relative w-[80%] ml-1 mt-3 border text-[12px] border-gray-400 rounded-md px-2 py-1 shadow-md text-start overflow-hidden outline-none flex items-center ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60" : ""}`}
              >
                <span className="truncate block w-full pr-6">
                  {selectedEmpInDrop && selectedEmpInDrop.index === index
                    ? `${selectedEmpInDrop.emp.EmpFirstName} ${selectedEmpInDrop.emp.EmpLastName}`
                    : selectedEmp?.[index]
                    ? `${selectedEmp[index].EmpFirstName} ${selectedEmp[index].EmpLastName}`
                    : person?.name}
                </span>

                <ExpandMoreIcon className="absolute right-0" />
              </button>

              {openMenuIdx === index && !isViewOnly && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="absolute w-[80%] z-[1999] top-10 left-0 p-1 bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1 max-h-40 overflow-y-auto"
                >
                  <>
                    {employees
                      .filter(
                        (emp) =>
                          !employeeWithTasks?.empsToExclude?.includes(emp?._id)
                      )
                      .filter(
                        (emp) =>
                          emp.servicetype === person.TypeService &&
                          !emp.customRoles?.includes("project manager") &&
                          !(
                            `${emp.EmpFirstName} ${emp.EmpLastName}`.trim() ===
                              person.name.trim() &&
                            emp.EmpEmail === person.email
                          )
                      )
                      .filter(
                        (emp) =>
                          !employeeWithTasks?.AllEmpIds?.includes(emp?._id)
                      )
                      .map((emp) => (
                        <div
                          key={emp._id}
                          className="p-1 hover:bg-gray-200 text-start z-[996] cursor-pointer"
                          onClick={() => {
                            setOpenMenuIdx(null);
                            setSelectedPerson(person);
                            setPendingAssignIndex(index);
                            handleSelectEmp(index, emp);
                            setSelectedEmpInDrop({ index, emp });
                            setSelectedHardwareParts((prev) => ({
                              ...prev,
                              [index]: person?.hardwareItems || [],
                            }));
                            setSelectedDescriptions((prev) => ({
                              ...prev,
                              [index]: person?.descriptionList || [],
                            }));
                          }}
                        >
                          {emp.EmpFirstName} {emp.EmpLastName}
                        </div>
                      ))}
                  </>
                </div>
              )}
            </div>
          </div>

          <div className=" w-[30rem] py-2">
            <div className="gap-3 flex justify-center items-center pb-1">
              <div>
                <button
                  onClick={() =>
                    setSelectedTab(
                      (prev) =>
                        prev.index === index && prev.tab === "tasktable"
                          ? { index: null, tab: null } // toggle close if already open
                          : { index, tab: "tasktable" } // open new
                    )
                  }
                  className={`px-2 py-1 rounded-md border border-gray-200 text-black ${
                    selectedTab.index === index &&
                    selectedTab.tab === "tasktable"
                      ? "bg-blue-600 text-white" // active state
                      : "bg-white border border-gray-200 text-black" // inactive state
                  }`}
                >
                  {row.TypeService?.toLowerCase().includes("hardware")
                    ? "Part List"
                    : "Effort Expenses"}
                </button>
              </div>
              <div>
                <button
                  onClick={() =>
                    setSelectedTab(
                      (prev) =>
                        prev.index === index && prev.tab === "otherexpenses"
                          ? { index: null, tab: null } // toggle close if already open
                          : { index, tab: "otherexpenses" } // open new
                    )
                  }
                  className={`px-2 py-1 rounded-md border border-gray-200 text-black ${
                    selectedTab.index === index &&
                    selectedTab.tab === "otherexpenses"
                      ? "bg-blue-600 text-white" // active state
                      : "bg-white border border-gray-200 text-black" // inactive state
                  }`}
                >
                  Other Expenses
                </button>
              </div>
            </div>

            <>
              {row?.TypeService?.toLowerCase().includes("hardware") &&
                selectedTab.index === index &&
                selectedTab.tab === "tasktable" && (
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    className="w-full h-full justify-center pb-5"
                  >
                    <div className="w-full border border-gray-300 overflow-hidden">
                      <div className="grid grid-cols-3 bg-blue-500 text-white text-[11px]">
                        <div className="p-1 border-r  text-center">
                          Total Parts{""}
                        </div>
                        <div className="p-1 border-r text-center">
                          Total Price ({currency})
                        </div>
                        <div className="p-1 text-center">Action</div>
                      </div>

                      <div className="grid grid-cols-3 bg-white text-black text-[11px]">
                        <div className="p-1 border-r border-blue-200 text-center">
                          {person?.hardwareItems?.length}
                        </div>
                        <div className="p-1 border-r border-blue-200 text-center">
                          {USAComma(
                            person?.hardwareItems?.reduce((sum, item) => {
                              return sum + Number(item.totalprice || 0);
                            }, 0)
                          )}{" "}
                        </div>
                        <div
                          title="Download Hardware Part List"
                          onClick={() =>
                            downloadPDFHardware(person?.hardwareItems)
                          }
                          className="p-1 text-center cursor-pointer hover:bg-blue-50"
                        >
                          Download
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {selectedTab.index === index &&
                selectedTab.tab === "otherexpenses" &&
                row?.TypeService?.toLowerCase().includes("hardware") && (
                  <div className="w-full border border-gray-300 overflow-hidden">
                    <div className="grid grid-cols-3 bg-blue-500 text-white text-[11px]">
                      <div className="p-1 border-r  text-center">
                        Total Descriptions{" "}
                      </div>
                      <div className="p-1 border-r text-center">
                        Total Amount ({currency})
                      </div>
                      <div className="p-1 text-center">Action</div>
                    </div>

                    {/* Row */}
                    <div className="grid grid-cols-3 bg-white text-black text-[11px]">
                      <div className="p-1 border-r border-blue-200 text-center">
                        {person?.descriptionList?.length}
                      </div>
                      <div className="p-1 border-r border-blue-200 text-center">
                        {USAComma(
                          person?.descriptionList?.reduce((sum, item) => {
                            return sum + Number(item.value || 0);
                          }, 0)
                        )}{" "}
                      </div>
                      <div
                        title="Download Description List"
                        onClick={() =>
                          downloadPDFHardwareDescriptions(
                            person?.descriptionList
                          )
                        }
                        className="p-1 text-center cursor-pointer hover:bg-blue-50"
                      >
                        Download
                      </div>
                    </div>
                  </div>
                )}
            </>
          </div>

          <div className="w-28 flex justify-center items-center pb-2">
            <>
              {person?.TypeService?.toLowerCase().includes("hardware") && (
                <>
                  <div className="flex flex-col pt-2">
                    <button
                      disabled={isViewOnly || !selectedEmp[index]}
                      onClick={() => {
                        if (isViewOnly) return;
                        setConfirmAssignPopup(true);
                        setSelectedPerson(person);
                        setPendingAssignIndex(index);
                      }}
                      className={`px-2 py-1 rounded-md
                                                 ${isViewOnly
                                                   ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60 pointer-events-none"
                                                   : selectedEmp[index]
                                                     ? "bg-blue-600 hover:bg-blue-800 text-white"
                                                     : "bg-gray-300 text-gray-600 cursor-not-allowed"
                                                 }`}
                    >
                      Assign
                    </button>

                    <button
                      disabled={isViewOnly}
                      onClick={() => {
                        if (isViewOnly) return;
                        setCancelPerson(person);
                        setCancelEmpBeforeAssign(true);
                      }}
                      className={`px-2 py-1 rounded-md mt-2 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-60 pointer-events-none" : "bg-red-500 text-white"}`}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </>
          </div>

          {cancelpopPerson && (
            <div className="fixed inset-0 z-[3400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
              <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                <button
                  onClick={() => setCancelPopPerson(false)}
                  className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                >
                  Close
                </button>
                <h2 className="text-[16px]">
                  Project Name :{" "}
                  <span className="font-semibold">
                    {cancelPerson?.ProjectName}
                  </span>
                </h2>

                <p className="mt-3 text-[14px] leading-6">
                  In order to cancel all response of
                  <span className="text-blue-800 font-semibold">
                    {" "}
                    {cancelPerson?.name || ""}{" "}
                  </span>{" "}
                  <br /> including effort expenses and other expenses ?.
                  <br />
                  You need to select another resource from below dropdown.
                </p>

                <div
                  ref={dropdownRefCancelOp}
                  className="w-full relative flex flex-col justify-start p-0 rounded-xl border-3 "
                >
                  <div className="relative w-[23%] ml-1 mt-3">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenCancelOpMenuIdx((prev) =>
                          prev === index ? null : index
                        );
                      }}
                      className="w-full border text-[12px] border-gray-400 rounded-md px-2 py-1 shadow-md text-start overflow-hidden outline-none flex items-center relative"
                    >
                      <span className="truncate block w-full pr-6">
                        {selectedCancelAssignOpPerson
                          ? `${selectedCancelAssignOpPerson.EmpFirstName} ${selectedCancelAssignOpPerson.EmpLastName}`
                          : "Select Resource"}
                      </span>
                      <ExpandMoreIcon className="absolute right-1" />
                    </button>

                    {openCancelOpMenuIdx === index && (
                      <div
                        className="absolute w-full z-[1999] top-9 left-0 bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1 max-h-40 overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {filteredCancelEmployee
                          ?.filter(
                            (emp) =>
                              !cancelPerson?.email?.includes(emp?.EmpEmail)
                          )
                          ?.map((emp) => (
                            <div
                              key={emp._id}
                              className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                              onClick={() => {
                                setSelectedCancelAssignOpPerson(emp);
                                setOpenCancelOpMenuIdx(null);
                              }}
                            >
                              {emp.EmpFirstName} {emp.EmpLastName}
                            </div>
                          ))}

                        {filteredCancelEmployee?.filter(
                          (emp) =>
                            emp.servicetype === person.TypeService &&
                            !emp.customRoles?.includes("project manager")
                        ).length === 0 && (
                          <div className="p-1 text-gray-500">
                            No matching employees
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex justify-start gap-4 mt-4 mb-6">
                  <button
                    disabled={!selectedCancelAssignOpPerson}
                    onClick={() => {
                      handleCancelAssignOpSubmit(cancelPerson);
                      setCancelPopPerson(false);
                    }}
                    className={`${
                      selectedCancelAssignOpPerson
                        ? "bg-[#e32278]"
                        : "cursor-default bg-[#e28fb5]"
                    } py-2 px-7  text-white rounded-lg `}
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => {
                      setCancelPopPerson(false);
                    }}
                    className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}

          {confirmAssignPopup && pendingAssignIndex !== null && (
            <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
              <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                <button
                  onClick={() => setConfirmAssignPopup(false)}
                  className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                >
                  Close
                </button>

                <p className="mt-6 text-lg font-medium">
                  Are you sure you want to{" "}
                  {selectedEmpInDrop?.emp
                    ? "assign"
                    : selectedEmp[pendingAssignIndex]?.EmpEmail ===
                      selectedPerson.email
                    ? "Re-assign"
                    : ""}{" "}
                  these tasks to{" "}
                  <span className="text-blue-600">
                    {selectedEmpInDrop
                      ? `${selectedEmpInDrop.emp?.EmpFirstName} ${selectedEmpInDrop.emp?.EmpLastName}`
                      : `${selectedEmp[pendingAssignIndex]?.EmpFirstName} ${selectedEmp[pendingAssignIndex]?.EmpLastName}`}
                  </span>
                  ?
                </p>

                <div className="flex justify-start gap-4 mt-6">
                  <button
                    onClick={() => {
                      if (
                        selectedPerson?.TypeService?.toLowerCase().includes(
                          "hardware"
                        )
                      ) {
                        handleOtherOPHardwareDescriptionAssign(
                          pendingAssignIndex
                        );
                        setConfirmAssignPopup(false); // close popup
                        setPendingAssignIndex(null); // reset index
                      } else {
                      }
                    }}
                    className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => {
                      setConfirmAssignPopup(false);
                      setPendingAssignIndex(null);
                    }}
                    className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}

          {cancelEmpBeforeAssign && (
            <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
              <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
                <button
                  onClick={() => setCancelEmpBeforeAssign(false)}
                  className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
                >
                  Close
                </button>

                <p className="mt-6 text-lg font-medium">
                  Are you sure you want to cancel all responses of{" "}
                  <span className="text-blue-600">{cancelPerson?.name} ?</span>
                </p>

                <div className="flex justify-start gap-4 mt-6">
                  <button
                    onClick={() => {
                      handleCancelAssignOpSubmit(cancelPerson);
                    }}
                    className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => {
                      setCancelPerson(null);
                      setCancelEmpBeforeAssign(false);
                    }}
                    className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default OldTaskDetailsHardware;
